import { render, staticRenderFns } from "./index.vue?vue&type=template&id=040fff9d&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadcrumbs: require('/home/vsts/work/1/a/NuxtApp/components/app/Breadcrumbs.vue').default,SkeletonBrandList: require('/home/vsts/work/1/a/NuxtApp/components/skeleton/BrandList.vue').default,BaseTouchScroll: require('/home/vsts/work/1/a/NuxtApp/components/base/TouchScroll.vue').default,BrandImageItem: require('/home/vsts/work/1/a/NuxtApp/components/brand/ImageItem.vue').default})
